import classNames from 'classnames'
import { useMemo } from 'react'

import { Button } from 'core-components/library/button'
import { Menu } from 'core-components/library/menu'
import { Tooltip } from 'core-components/library/tooltip'
import { BaseCrud, Static } from 'core-components/types'

import styles from './AddWrap.module.scss'

const AddWrap = (props: { callback: (whereto: string) => void }) => {
  const source = useMemo(() => {
    return new BaseCrud({
      fetcher: new Static([
        { id: 'toLeft', label: 'Widget to left', parent: '' },
        { id: 'toTop', label: 'Widget to top', parent: '' },
        { id: 'toRight', label: 'Widget to right', parent: '' },
        { id: 'toBottom', label: 'Widget to bottom', parent: '' },
      ]),
      keyField: 'id',
      hierarchyField: 'parent',
      hierarchyRoot: '',
    })
  }, [])

  const performMenuFunction = (id: string) => {
    switch (id) {
      case 'toLeft':
        props.callback('left')
        break
      case 'toTop':
        props.callback('top')
        break
      case 'toRight':
        props.callback('right')
        break
      case 'toBottom':
        props.callback('bottom')
        break
    }
  }

  return (
    <Menu
      classes={{
        popupWrap: classNames(styles.popupWrap),
      }}
      __popupTestId={'addWidgetMenuPopup'}
      subMenuClasses={{
        row: styles.row,
        cell: styles.cell,
        iconCell: styles.iconCell,
      }}
      content={() => (
        <Tooltip tipContent={() => <>New Widget</>}>
          <Button
            variant={'text'}
            color={'grey'}
            iconButton={'kbase kbase-add'}
            __testId={'addWidgetButton'}
          />
        </Tooltip>
      )}
      source={source}
      caption={'label'}
      onChoose={(id) => performMenuFunction(id)}
    />
  )
}

export { AddWrap }
